"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _excluded = ["width", "height", "viewBox", "fill", "title"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var FacebookLogo = function FacebookLogo(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 30 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 30 : _ref$height,
    _ref$viewBox = _ref.viewBox,
    viewBox = _ref$viewBox === void 0 ? "0 0 35 35" : _ref$viewBox,
    _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? "#fffffe" : _ref$fill,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? "Facebook logo" : _ref$title,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    width: width,
    height: height,
    viewBox: viewBox
  }, rest), /*#__PURE__*/_react["default"].createElement("title", null, title), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M35 17.6C35 7.89 27.16 0 17.5 0S0 7.88 0 17.6C0 26.4 6.4 33.69 14.77 35V22.7h-4.45v-5.1h4.45v-3.87c0-4.41 2.6-6.85 6.6-6.85 1.92 0 3.92.34 3.92.34v4.33h-2.2c-2.18 0-2.86 1.36-2.86 2.75v3.3h4.86l-.78 5.1h-4.08V35A17.58 17.58 0 0 0 35 17.6"
  }));
};
var _default = exports["default"] = FacebookLogo;